import { FC } from "react";
import { G, Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdAdd: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 30 30" fill="none" {...props}>
      <G transform="translate(-34.322034,-986.26049)">
        <Path
          d="m 48.322034,986.26049 v 14.00001 h -14 v 2 h 14 v 14 h 2 v -14 h 14 v -2 h -14 v -14.00001 z"
          fill="currentColor"
          fillOpacity="1"
          stroke="none"
          marker="none"
        />
      </G>
    </Svg>
  );
};

export default PdAdd;
